// extracted by mini-css-extract-plugin
export default {"feedback_card":"Feedback_feedback_card__GctLD","icon_card":"Feedback_icon_card__H7JU9","icons":"Feedback_icons__d70XP","img_card":"Feedback_img_card__Uq3PO"};